interface ToggleProps {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  label: string
  id?: string
}

/** Переключатель (switch) — доступная кнопка role=switch с aria-checked. */
export function Toggle({ checked, onChange, disabled = false, label, id }: ToggleProps) {
  return (
    <button
      type="button"
      id={id}
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      className={`toggle${checked ? ' is-on' : ''}`}
      onClick={() => !disabled && onChange(!checked)}
    >
      <span className="toggle__knob" />
    </button>
  )
}
